import Lottie from 'react-lottie'

import { Text } from '@/shared/components/typography'

import purchaseAnimation from '../../../../../../../../../public/paymentcheck.json'

const DefaultTemplate = ({ name }: { name: string }) => {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: purchaseAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }
  return (
    <div className="flex flex-col items-center gap-6 text-center">
      <Lottie options={defaultOptions} width={50} height={50} />
      <Text level="text1" weight="bold" color="text090">
        지금 주차를 시작해 주세요.
      </Text>
      <Text level="text2" color="caution070">
        {`공유된 공간 확인 후 주차해 주세요.`}
        <br />
        {`${name} 구간 내 빈자리에 주차해주세요.`}
        <br />
        {`(바닥표시${name} 또는 ▵-${name}-○)`}
      </Text>
    </div>
  )
}

export default DefaultTemplate
